<template>
  <h1 class="text-xl mb-4"><slot /></h1>
</template>
